import React, { useEffect } from 'react'
import { useState } from 'react'
import Modal from '../../controls/Modal'
import LodingButton from '../../controls/LodingButton'
import { useFormik } from 'formik'
import Input from '../../controls/Input'
import * as yup from 'yup'
import Select from '../../controls/Select'

const schema = yup.object().shape({
    Comment: yup.string().required("Comment is required."),
    BloodPressure: yup.string().required("Blood Pressure is required"),
    PatientBond: yup.string().required("Bond is required"),
    PatientType: yup.string().required("Type is required"),
    Weight: yup.string().required("Weight is required"),
    PatientName: yup.string().required("Patient Name is required"),
    Mobile: yup.string().required("Mobile is required"),
})

export default function ConfirmOnline({ isOpen, setIsOpen, id, confirmOnline, loding, item }) {

    const { values, handleBlur, handleChange, handleSubmit, errors, touched, isValid, setValues } = useFormik({
        initialValues: {
            Id: 0,
            Comment: "N/A",
            BloodPressure: "N/A",
            PatientBond: "Cash",
            PatientType: "Normal",
            Weight: 0,
            PatientName: "",
            Mobile: "",
        },
        enableReinitialize: true,
        validationSchema: schema,
        onSubmit(val) {
            confirmOnline(val, setValues)
        }
    })

    useEffect(() => {
        if (item)
            setValues({
                Id: item.id,
                Comment: "N/A",
                BloodPressure: "N/A",
                PatientBond: "Cash",
                PatientType: "Normal",
                Weight: item.weight,
                PatientName: item.patientName,
                Mobile: item.mobile,
            })
    }, [item])

    return (
        <Modal isOpen={isOpen} setIsOpen={setIsOpen} title={"ConfirmOnline"}>
            <form onSubmit={handleSubmit}>
                <div className="p-6 space-y-6">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                        <div>
                            <label htmlFor="PatientName" className="block mb-2 text-sm font-medium text-gray-900">Name</label>
                            <Input placeholder="Name"
                                type="text"
                                id="PatientName"
                                Icon={"@"}
                                value={values.PatientName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isError={errors.PatientName && touched.PatientName}
                            />
                            {errors.PatientName && touched.PatientName && <p className='text-red-600 text-xs'>{errors.PatientName}</p>}
                        </div>
                        <div>
                            <label htmlFor="Mobile" className="block mb-2 text-sm font-medium text-gray-900">Mobile</label>
                            <Input placeholder="Mobile"
                                type="text"
                                id="Mobile"
                                Icon={"@"}
                                value={values.Mobile}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isError={errors.Mobile && touched.Mobile}
                            />
                            {errors.Mobile && touched.Mobile && <p className='text-red-600 text-xs'>{errors.Mobile}</p>}
                        </div>
                        <div>
                            <label htmlFor="Weight" className="block mb-2 text-sm font-medium text-gray-900">Weight</label>
                            <Input placeholder="Weight"
                                type="number"
                                id="Weight"
                                Icon={"@"}
                                value={values.Weight}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isError={errors.Weight && touched.Weight}
                            />
                            {errors.Weight && touched.Weight && <p className='text-red-600 text-xs'>{errors.Weight}</p>}
                        </div>
                        <div>
                            <label htmlFor="BloodPressure" className="block mb-2 text-sm font-medium text-gray-900">Blood Pressure</label>
                            <Input placeholder="BloodPressure"
                                id="BloodPressure"
                                type="text"
                                Icon={"@"}
                                value={values.BloodPressure}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isError={errors.BloodPressure && touched.BloodPressure}
                            />
                            {errors.BloodPressure && touched.BloodPressure && <p className='text-red-600 text-xs'>{errors.BloodPressure}</p>}
                        </div>
                        <div>
                            <label htmlFor="PatientType" className="block mb-2 text-sm font-medium text-gray-900">
                                Patient Type
                            </label>
                            <Select
                                Icon={'@'}
                                id="PatientType"
                                name="PatientType"
                                value={values.PatientType}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isError={errors.PatientType && touched.PatientType}
                            >
                                <option value="Normal">Normal</option>
                                <option value="New">New</option>
                                <option value="Under NF">Under NF</option>
                            </Select>
                            {errors.PatientType && touched.PatientType && (
                                <p className="text-red-600 text-xs">{errors.PatientType}</p>
                            )}
                        </div>
                        <div>
                            <label htmlFor="PatientBond" className="block mb-2 text-sm font-medium text-gray-900">
                                Bond
                            </label>
                            <Select
                                Icon={'@'}
                                id="PatientBond"
                                name="PatientBond"
                                value={values.PatientBond}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isError={errors.PatientBond && touched.PatientBond}
                            >
                                <option value="Cash">Cash</option>
                                <option value="UPI">UPI</option>
                            </Select>
                            {errors.PatientBond && touched.PatientBond && (
                                <p className="text-red-600 text-xs">{errors.PatientBond}</p>
                            )}
                        </div>

                        <div className="sm:col-span-2">
                            <label htmlFor="Comment" className="block mb-2 text-sm font-medium text-gray-900">Comment</label>
                            <Input placeholder="Comment"
                                type="text"
                                id="Comment"
                                Icon={"@"}
                                value={values.Comment}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isError={errors.Comment && touched.Comment}
                            />
                            {errors.Comment && touched.Comment && <p className='text-red-600 text-xs'>{errors.Comment}</p>}
                        </div>
                    </div>
                </div>
                <div className="flex items-center p-6 space-x-3 rtl:space-x-reverse border-t border-gray-200 rounded-b">
                    {!loding ?
                        <button type="submit" className={!isValid ? "btn-blue-disabled" : "btn-blue"} disabled={!isValid}>Save</button>
                        : <LodingButton text="Wait.." />
                    }
                </div>
            </form>
        </Modal>
    )
}